import * as Yup from 'yup'

export const FolderSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.'),
  client_id: Yup.number().integer().required('This field is required.')
});
